(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bOFpt", function(module, exports) {

$parcel$export(module.exports, "initTyped", function () { return $89a47c5b939b0560$export$b9556ded0ece410e; });
// Typed content and dynamic feature initialization
const $89a47c5b939b0560$var$typedContent = {
    en: [
        "Warehouse Manager",
        "Web Developer",
        "Husband (of Barbara M\xe1rku)",
        "Traveller",
        "Video Game Fanatic... :)"
    ],
    hu: [
        "Rakt\xe1rigazgat\xf3",
        "Webfejleszt\u0151",
        "F\xe9rj (M\xe1rku Barbar\xe1nak)",
        "Vil\xe1gutaz\xf3",
        "Videoj\xe1t\xe9k fanatikus... :)"
    ],
    nl: [
        "Warehouse Manager",
        "Webontwikkelaar",
        "Echtgenoot (van Barbara M\xe1rku)",
        "Wereldreiziger",
        "Videospel fanatiek... :)"
    ]
};
function $89a47c5b939b0560$export$b9556ded0ece410e(lang) {
    const targetElement = document.querySelector("#typed-effect"); // Target your typed effect element
    if (!targetElement) {
        console.error("Typed effect target element not found!");
        return;
    }
    new Typed("#typed-effect", {
        strings: $89a47c5b939b0560$var$typedContent[lang],
        typeSpeed: 50,
        backSpeed: 50,
        backDelay: 1000,
        loop: true
    });
}

});


parcelRequire("bOFpt");
})();
//# sourceMappingURL=portfolio.8df0d8f8.js.map
